import styled, { createGlobalStyle } from 'styled-components';
import { Button, Avatar, ButtonProps, AvatarProps } from 'antd';
import { FunctionComponent } from 'react';

export const GlobalStyle = createGlobalStyle`
  body {
    height: auto;
    overflow: auto;
  }
  #ywApp {
    height: auto;
    overflow: auto;
    > div {
      &:last-child {
        height: 100%;
        overflow: auto;
      }
    }
  }
`;

export const LoginStyle = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  background-color: #000;
  width: auto;
  height: auto;
  video {
    width: 100%;
    height: 100vh;
    object-fit: cover;
    -o-object-fit: cover;
    position: absolute;
    top: 0;
    z-index: -1;
  }
`;

export const FormStyle: any = styled.div`
  position: absolute;
  height: 400px;
  top: 50%;
  left: ${(props: { left: string }) => props.left || '78.75%'};
  transform: translate(-50%, -50%);
  background: #fff;
  display: flex;
  border-radius: 4px;
  box-shadow: 0 0 10px hsla(0, 0%, 58.8%, 0.2);
  overflow: hidden;
  z-index: 100;

  @media (max-width: 500px) {
    left: 50%;
  }
`;
export const FormBoxStyle = styled.div`
  width: 350px;
  height: 100%;
  padding: 30px;
  box-sizing: border-box;
  .title {
    color: #333333;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 30px;
    text-align: center;
    margin-top: 20px;
  }
  .back {
    background: url('https://yw-fed-static.oss-cn-hangzhou.aliyuncs.com/ywwl-website/login/chevron-left.png') no-repeat center left;
    background-size: 20px 20px;
    position: relative;
    cursor: pointer;
    padding-left: 22px;
    width: 100px;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    margin-bottom: 30px;
    margin-top: 20px;
  }
  .ant-input {
    height: 40px;
  }
  .ant-input-password,
  .ant-input-affix-wrapper {
    .ant-input {
      height: 30px;
    }
  }
  .ant-form-item {
    text-align: left;
    margin-bottom: 16px;
  }
  .ant-form-item-with-help {
    margin-bottom: 0px;
  }
  input::-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
    transition: background-color 50000s ease-in-out 0s;
  }
  .nc_wrapper {
    width: 290px !important;
  }
  .nc_scale,
  .nc-lang-cnt,
  .nc_wrapper,
  .btn_slide {
    height: 40px !important;
    line-height: 40px;
  }
  .nc_iconfont {
    height: 40px !important;
  }
  .ant-btn-primary {
    background: #0077ff;
    border-radius: 4px;
    border-color: #0077ff;
  }
`;

export const LoginLogoStyle = styled.img`
  display: block;
  margin: 0 auto 40px;
  height: 40px;
`;

export const LoginScanStyle = styled.div`
  text-align: center;
  position: relative;
  height: 300px;
  width: 100%;
  overflow: hidden;

  .title{
    display: flex;
    align-items: center;
    color:#2090FF;
    font-size: 12px;
    margin-left: 101px;

    img{
      width: 20px;
      margin-right: 10px;
    }
  }
  .tip{
    margin-top: 220px;
    font-size: 10px;
    color: #999;
  }
`;

export const CodeBtnStyle: FunctionComponent<ButtonProps> = styled(Button)`
  margin-left: 10px;
  padding: 0;
`;

export const HeaderAvatarStyle: FunctionComponent<AvatarProps> = styled(Avatar)`
  margin-bottom: 6px;
`;

export const ToolWrapStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 18px;
  .ant-btn-text {
    padding: 0px;
  }
`;

export const AuthUserActionStyle = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  .user-head-img {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-bottom: 6px;
  }
`;

export const ChangeIconStyle: any = styled.div`
  background: url(${(props: { icon: string; hoverIcon: string }) => props.icon}) no-repeat top right;
  background-size: 56px 56px;
  cursor: pointer;
  width: 56px;
  height: 56px;
  position: absolute;
  top: 0px;
  right: 0;
  border-radius: 4px;
  span {
    position: absolute;
    top: 18px;
    right: 56px;
    padding: 3px 12px;
    background: #cce4ff;
    border-radius: 4px;
    min-width: 74px;
    text-align: center;
    font-size: 12px;
    color: #0077ff;
    &:after {
      content: '';
      display: inline-block;
      width: 8px;
      height: 8px;
      position: absolute;
      top: 8px;
      right: -4px;
      background: #cce4ff;
      transform: rotate(45deg);
    }
  }
  &:hover {
    background: url(${(props: { icon: string; hoverIcon: string }) => props.hoverIcon}) no-repeat top right;
    background-size: 56px 56px;
  }
`;


export const LoginWayStyle = styled.div`
  width: 130px;
  margin: 0 auto;
  margin-bottom: -16px;
`